<template>
  <div>
    <AppHeader />

    <UMain as="main">
      <slot />
    </UMain>

    <AppFooter />
  </div>
</template>
